
import React from 'react';
import { Mail, Phone, Building, Clock, Users, ExternalLink } from 'lucide-react';
import PolicySectionCard from '@/components/policy/PolicySectionCard';
import SocialLinks from '@/components/layout/SocialLinks';
import PageHeader from '@/components/layout/PageHeader';
import { motion } from 'framer-motion';
import PolicyLayout from '@/components/policy/PolicyLayout';

const ContactUs = () => {
  return (
    <PolicyLayout>
      {/* Header Section */}
      <PageHeader
        icon={<Mail className="w-8 h-8 text-primary" />}
        title="Contact Us"
        description="We'd love to hear from you! Whether you're a student, educator, institution, or curious learner, your questions, suggestions, or partnership proposals are always welcome."
      />

      {/* Cards Grid */}
      <motion.div 
        className="space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          <PolicySectionCard
            title="General Inquiries"
            icon={Users}
            variant="indigo"
          >
            <p className="mb-4">Got a question about Edaptica or our features?</p>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-white/90" />
                <span>Email: support@edaptica.com</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-white/90" />
                <span>Call/WhatsApp: 07992096907</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-white/90" />
                <span>Support Hours: Monday to Friday, 10 AM – 6 PM (IST)</span>
              </div>
            </div>
          </PolicySectionCard>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <PolicySectionCard
            title="Institutional & Enterprise Partnerships"
            icon={Building}
          >
            <p className="mb-4">Interested in bringing Edaptica to your school, coaching center, or organization?</p>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-white/90" />
              <span>Email: support@edaptica.com</span>
            </div>
          </PolicySectionCard>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <PolicySectionCard
            title="Media & Press"
            icon={ExternalLink}
          >
            <p className="mb-4">For interviews, press releases, or speaking opportunities:</p>
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-white/90" />
              <span>Email: support@edaptica.com</span>
            </div>
          </PolicySectionCard>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <PolicySectionCard
            title="Registered Office"
            icon={Building}
          >
            <p>Cibeto Technologies Private Limited</p>
            <p>L-16-L-18, Uday Tower, Vijayant Khand</p>
            <p>Gomti Nagar, Lucknow-226010</p>
            <p>Uttar Pradesh, India</p>
            <p className="mt-2 italic">Note: Visits by appointment only</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <PolicySectionCard
            title="Follow Us"
            icon={Users}
          >
            <p className="mb-4">Stay connected for updates, events, and educational tips:</p>
            <div className="flex justify-center">
              <SocialLinks darkMode={false} />
            </div>
          </PolicySectionCard>
        </motion.div>
      </motion.div>

      {/* Footer */}
      <motion.footer 
        className="text-center text-sm text-muted-foreground pt-8 mt-8 border-t"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        © 2025 Cibeto Technologies Private Limited. All rights reserved.
      </motion.footer>
    </PolicyLayout>
  );
};

export default ContactUs;
